// Carrier names arrive exactly as whoever marked the parcel shipped typed them
// ("usps", "Usps", "USPS"). Known carriers render in their brand spelling;
// anything else is shown as entered.
const KNOWN_CARRIERS: Record<string, string> = {
  usps: 'USPS',
  ups: 'UPS',
  fedex: 'FedEx',
  fedexdefault: 'FedEx',
  dhl: 'DHL',
  dhlexpress: 'DHL Express',
};

export function formatCarrier(name: string): string {
  const key = name.toLowerCase().replace(/[^a-z]/g, '');
  return KNOWN_CARRIERS[key] ?? name.trim();
}
